import { render, staticRenderFns } from "./title-element.vue?vue&type=template&id=14a8d90d&scoped=true&"
import script from "./title-element.vue?vue&type=script&lang=js&"
export * from "./title-element.vue?vue&type=script&lang=js&"
import style0 from "./title-element.vue?vue&type=style&index=0&id=14a8d90d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a8d90d",
  null
  
)

export default component.exports